export class CheckDto {

  public readonly result!: boolean;
  public readonly messageCode: string | undefined;

  constructor(init?: Partial<CheckDto> | undefined) {
    Object.assign(this, init);
  }

  public isSuccess(): boolean {
    return this.result;
  }
}
